// main.jsx or index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App"; // ✅ case-sensitive on Linux or Mac
import "./index.css";
import { CartProvider } from "./context/CartContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
<React.StrictMode>
    <CartProvider>
      <App />
    </CartProvider>
  </React.StrictMode>);
